import { render, staticRenderFns } from "./ModalCreateTermPolicy.vue?vue&type=template&id=0212aadc&scoped=true"
import script from "./ModalCreateTermPolicy.vue?vue&type=script&lang=js"
export * from "./ModalCreateTermPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0212aadc",
  null
  
)

export default component.exports